import React, { memo, useCallback } from "react"
import fetchAPI from "../../../../../lib/utils/fetch-api"
import { ExportExcelButton, format2Print, formatDecimalSeparator } from "src/react-app/components/v2/export-excel-button"
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import {formatDate} from "../../../../components/v2/export-excel-button/model/lib/formatDate";

dayjs.extend(utc)
dayjs.extend(timezone)

export interface RouteSheetsPrintButtonProps {
    path: string
    columns: any[]
}

const excludeColumns = ['stage']
const timeZone = 'Europe/Moscow'

export const PrintButton: React.FC<RouteSheetsPrintButtonProps> = memo((props) => {
    const { path, columns } = props

    const localColumns = columns
      .filter(column => !excludeColumns.includes(column.key))
      .map(column => {
          return column
      })

    const formatTime = (timeString: string): string => {
        if (!timeString) return ''
        if (timeString.includes('T') && timeString.endsWith('Z')) {
            return dayjs.utc(timeString).tz(timeZone).format('HH:mm')
        }
        return dayjs(timeString).format('HH:mm')
    }

    const handlePrintClick = useCallback(async () => {
        try {
            const url = new URL(path, window.location.origin)
            url.searchParams.set('excel', 'y')

            const response = await fetchAPI(url.toString())
            const data = response.data
            if (!data) {
                return
            }

            const viewColumnNames = localColumns.map((column) => column.dataIndex).filter(key => !excludeColumns.includes(key))
            const count = data.length

            for (let i = 0; i < count; i++) {
                let keys = Object.keys(data[i])
                keys.forEach((key) => {
                    if (!viewColumnNames.includes(key)) {
                        return
                    }
                    if (key === 'date') {
                        data[i][key] = formatDate(data[i][key], 'DD.MM.YYYY')
                        return
                    }
                    if (key === 'pyramid_numbers') {
                        data[i][key] = data[i][key] && Array.isArray(data[i][key]) ? data[i][key].join(', ') : data[i][key]
                        return
                    }
                    data[i][key] = formatDecimalSeparator(format2Print(key, data[i][key]))
                })
            }

            return data
        } catch (e) {
            console.log('handlePrintClick', e)
        }
    }, [columns, localColumns, path])

    return (
      <ExportExcelButton
        fileName={'Маршрутные листы'}
        path={path}
        columns={localColumns}
        onPrintClick={handlePrintClick}
      />
    )
})
